import { create } from 'zustand';
import { Label } from 'web/model/Label';

interface PhoneCallState {
    showPhoneCallUI: boolean;
    label: Label | null;
    cancelAdd: () => void;
    setShowPhoneCallUI: (show: boolean) => void;
    setDetails: (showPhoneCallUI: boolean, label: Label | null) => void;
}

export const usePhoneCallStore = create<PhoneCallState>((set) => ({
    showPhoneCallUI: false,
    label: null,
    cancelAdd: () => set({ showPhoneCallUI: false, label: null }),
    setShowPhoneCallUI: (show) => set({ showPhoneCallUI: show }),
    setDetails: (showPhoneCallUI: boolean | true, label: Label | null) => set({ showPhoneCallUI, label }),
}));
